import { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { registerAction, clearErrors, verifyTokenAction } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import { REGISTER_USER_RESET } from '../../../redux/constants/userConstant';
import { useParams } from "react-router-dom";
import PageNotFound from '../../PageNotFound/PageNotFound';
import Logo from "../../images/logo-black.png"


const Signup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token } = useParams();


    const { loading, error, message } = useSelector((state) => state.register);
    const { isAuthenticated } = useSelector((state) => state.verifyEmailStore);
    const { invite, error: tokenVerficationError, loading: tokenVerficationLoading } = useSelector((state) => state.verifyToken);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false)

    // 👇 For password hint display
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();


        if (!token) {
            toast.error("Admin-restricted signup is intentional: only invited users can join.");
            return;
        }

        if (!name) {
            toast.error("Please enter your name");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }

        if (!password) {
            toast.error("Please enter your password");
            return;
        }

        if (password.length < 8) {
            toast.error("Password should contain at least 8 characters");
            return;
        }


        const formData = new FormData();
        formData.append("name", name);
        formData.append("email", email);
        formData.append("password", password);
        formData.append("token", token);

        dispatch(registerAction(formData));
    };

    useEffect(() => {
        if (token) {

            dispatch(verifyTokenAction({ token }));

        }
    }, [token, dispatch])








    useEffect(() => {
        if (message) {
            toast.success(message);
            localStorage.setItem("email", email);
            navigate('/verify-email');
            dispatch({ type: REGISTER_USER_RESET })
        }
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (isAuthenticated) {
            navigate('/');
        }

        document.title = `REGISTER`;
    }, [error, message, navigate, dispatch, email, isAuthenticated]);



    useEffect(() => {

        document.title = 'SIGN UP'

    }, [])


    const getPasswordStrength = (password) => {
        let score = 0;

        if (/[a-zA-Z]/.test(password)) score++;      // any alphabet
        if (/\d/.test(password)) score++;            // number
        if (/[A-Z]/.test(password)) score++;         // uppercase
        if (/[^A-Za-z0-9]/.test(password)) score++; // special char

        return score; // 0 → 4
    };




    useEffect(() => {
        if (invite) {
            setEmail(invite.email || '')
        }
    }, [invite])


    return (
        <Fragment>
            {(loading || tokenVerficationLoading) ? (
                <Loader />
            ) : (
                tokenVerficationError ? <PageNotFound />
                    :
                    <section className="relative min-h-[100vh] w-full flex bg-white font-jakarta overflow-x-hidden">

                        {/* Left Side: Dark & Corporate (Hidden on mobile) */}
                        <div className="hidden lg:flex lg:w-[45%] bg-zinc-900 p-[5vmax] flex-col justify-between relative">
                          <div className="absolute inset-0 bg-[linear-gradient(to_bottom_right,rgba(255,255,255,0.05),transparent)] pointer-events-none"></div>
                          
                          <div className="relative z-10">
                            <img src={Logo} alt="Zonify Pro" className="w-[35%] invert" />
                          </div>
                          
                          <div className="relative z-10">
                            <span className="text-indigo-400 font-semibold uppercase text-sm tracking-widest mb-3 block">Join the Portal</span>
                            <h2 className="text-[3.5vmax] font-bold text-white leading-none mb-[1.5vmax]">Start managing your operations today.</h2>
                            <p className="text-[1.1vmax] text-zinc-400 font-light max-w-[85%] leading-relaxed">
                              Create your account and get access to the most advanced tools for order management and commission tracking.
                            </p>
                          </div>
                          
                          <div className="relative z-10 text-zinc-500 text-[0.85vmax] flex items-center gap-4">
                            <span>© 2026 Zonify Pro</span>
                            <span className="w-1 h-1 bg-zinc-700 rounded-full"></span>
                            <span>Privacy Policy</span>
                            <span className="w-1 h-1 bg-zinc-700 rounded-full"></span>
                            <span>Terms of Service</span>
                          </div>
                        </div>

                        {/* Right Side: Signup Form */}
                        <div className="flex-1 min-w-0 w-full flex items-center justify-center p-6 lg:p-12 bg-white relative">
                          
                          <div className="w-[calc(100vw_-_3rem)] max-w-md sm:w-full" data-aos="fade-up" data-aos-duration="1000">
                            
                            {/* Logo for mobile only */}
                            <div className="flex justify-center mb-8 lg:hidden">
                              <img src={Logo} alt="Zonify Pro" className="w-32" />
                            </div>
                            
                            <div className="mb-8 text-center lg:text-left">
                              <h4 className="text-2xl lg:text-3xl font-bold text-zinc-900 mb-2">Create your account</h4>
                              <p className="text-sm lg:text-base text-zinc-500">
                                Please fill in your details to get started.
                              </p>
                            </div>

                            <form className="flex flex-col w-full" onSubmit={handleSubmit}>
                              {/* Full Name */}
                              <div className="flex flex-col mb-5">
                                <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Full Name</label>
                                <input
                                  type="text"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  className="w-full px-4 py-3 rounded-lg border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 outline-none text-sm lg:text-base text-zinc-800 placeholder-zinc-400 bg-white transition-all shadow-sm"
                                  placeholder="John Doe"
                                />
                              </div>

                              {/* Email (Read-only) */}
                              <div className="flex flex-col mb-5">
                                <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Email Address</label>
                                <input
                                  type="text"
                                  value={email}
                                  onChange={(e) => { e.preventDefault(); }}
                                  className="w-full px-4 py-3 rounded-lg border border-zinc-200 outline-none text-sm lg:text-base text-zinc-500 bg-zinc-50 cursor-not-allowed shadow-sm"
                                  readOnly
                                />
                              </div>

                              {/* Password */}
                              <div className="flex flex-col mb-5">
                                <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Password</label>
                                <div className="relative">
                                  <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/\s/g, "");
                                      setPassword(value);
                                    }}
                                    onFocus={() => setIsPasswordFocused(true)}
                                    onBlur={() => setIsPasswordFocused(false)}
                                    className="w-full px-4 py-3 rounded-lg border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 outline-none text-sm lg:text-base text-zinc-800 placeholder-zinc-400 bg-white transition-all shadow-sm"
                                    placeholder="••••••••"
                                  />
                                  <button type="button"
                                    className="absolute inset-y-0 right-0 pr-4 flex items-center text-zinc-400 hover:text-zinc-600 transition-colors"
                                    onClick={() => setShowPassword(prev => !prev)}>
                                    <i className={`fa-regular ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                  </button>
                                </div>

                                {/* Password Hint */}
                                {isPasswordFocused && (
                                    <div className="flex justify-end gap-1.5 pt-2">
                                        {[1, 2, 3, 4].map((level) => {
                                            const strength = getPasswordStrength(password);
                                            let bg = "bg-zinc-200"; // default
                                            if (strength >= level) {
                                                if (strength === 1) bg = "bg-red-500";
                                                if (strength === 2) bg = "bg-orange-500";
                                                if (strength === 3) bg = "bg-yellow-500";
                                                if (strength === 4) bg = "bg-green-500";
                                            }
                                            return (
                                                <span
                                                    key={level}
                                                    className={`w-6 h-1 rounded-full transition-all duration-300 ${bg}`}
                                                />
                                            );
                                        })}
                                    </div>
                                )}
                              </div>

                              <button
                                type="submit"
                                className={`w-full py-3 rounded-lg font-medium text-sm lg:text-base transition-all mt-2
                                  ${(email === '' || password === '' || name === '' || getPasswordStrength(password) < 1) ? 
                                    'bg-zinc-100 text-zinc-400 cursor-not-allowed' : 
                                    'bg-zinc-900 text-white hover:bg-zinc-800 shadow-sm hover:shadow-md'}`}
                                disabled={email === '' || password === '' || name === '' || getPasswordStrength(password) < 1}
                              >
                                Sign Up
                              </button>

                              <div className="text-sm text-zinc-500 text-center mt-6">
                                Already have an account?
                                &nbsp;
                                <Link to="/login" className="font-medium text-zinc-900 hover:text-zinc-700 transition-colors underline underline-offset-4">
                                  Sign in
                                </Link>
                              </div>
                            </form>
                          </div>
                        </div>
                    </section>
            )}
        </Fragment>
    );
};

export default Signup;
